import { IModel, Model } from '.';
export interface IIdexxSpeciesModel extends IModel {
  idexxSpeciesId: number;
  name: string;
  code: string;
}
export class IdexxSpeciesModel extends Model implements IIdexxSpeciesModel {
  idexxSpeciesId: number;
  name: string;
  code: string;
  constructor(params: IIdexxSpeciesModel) {
    super(params);
    this.idexxSpeciesId = params.idexxSpeciesId;
    this.name = params.name;
    this.code = params.code;
  }
}
